export default {
  'commissionmanagement.commissionmanagement': 'Управление точками',
  'commissionmanagement.accountsnotify':
    'Пожалуйста, создайте банковский счет от	',
  'commissionmanagement.accountsnotify1': 'Ссылка, если у вас нет счета',
  'commissionmanagement.accountmanagement': 'Управление Банковскими счетами',
  'commissionmanagement.description': 'Описание',
  'commissionmanagement.bankaccount': 'Номер счета',
  'commissionmanagement.save': 'Сохранить',
  'commissionmanagement.addrequest': 'отправить запрос на снятие',
  'commissionmanagement.withdrawamount': 'Сумма снятия',
  'commissionmanagement.index': 'Показатель',
  'commissionmanagement.requestdate': 'Дата запроса',
  'commissionmanagement.requeststatus': 'Статус запроса',
  'commissionmanagement.withdrawtype': 'Тип вывода',
  'commissionmanagement.requestadd': 'Запрос на вывод добавлен успешно',
  'commissionmanagement.tryagain': 'Пожалуйста, попробуйте снова',
  'commissionmanagement.deleterequest': 'Удалить запрос на снятие средств',
  'commissionmanagement.disapprove':
    '«Невозможно удалить этот запрос», 	«Комиссия по управлению не подтверждено»	Отклоненные',
  'commissionmanagement.approve': 'Утвердить',
  'commissionmanagement.pending': 'В ожидании',
  'commissionmanagement.notpaid': 'Не оплачен',
  'commissionmanagement.paid': 'Оплачен',
  'commissionmanagement.showdetail': 'показать детали',
  'commissionmanagement.incomedetail': 'Детали дохода',
  'commissionmanagement.withdrawreport': 'Отчет о транзакциях',
  'commissionmanagement.transferpoints': 'переводные пункты',
  'commissionmanagement.buycard': 'купить телефонную карточку',
  'commissionmanagement.paybill': 'Оплатить счет',
  'commissionmanagement.spendpoints': 'Потратить очки',
  'commissionmanagement.lottery': 'лотерея',
  'commissionmanagement.earnpoints': 'Зарабатывайте очки',
  'commissionmanagement.redandantrequest':
    'Существует один ожидающий запрос. Пожалуйста, не отправляйте другой запрос',
  'commissionmanagement.exitfee': 'Плата за выезд',
  'commissionmanagement.requestreport': 'Отчет о запросах на снятие средств',
  'commissionmanagement.phrase': 'Описание документа',
  'commissionmanagement.documentdescription': 'номер документа',
  'commissionmanagement.transferamount': 'Переводные баллы',
  'commissionmanagement.pointamount': 'Сумма баллов ',
  'commissionmanagement.secondpassword': 'Второй пароль',
  'commissionmanagement.transfererror':
    'Сумма запрошенных баллов больше количества оставшихся баллов',
  'commissionmanagement.resecondpassword': 'Введите второй пароль еще раз',
  'commissionmanagement.wagenotify1': 'Согласны ли вы вычесть ',
  'commissionmanagement.wagenotify2': 'балл из заработной платы? ',
  'commissionmanagement.errorsecondpassword':
    'Второй пароль не зарегистрирован. Пожалуйста, сначала введите второй пароль',
  'commissionmanagement.wrongsecondpassword': 'Второй пароль неверный!',
  'commissionmanagement.successtransfer': 'Баллы успешно переведены',
  'commissionmanagement.notenoughpoint':
    'Запрошенные баллы не разрешены из-за приостановленных баллов',
  'commissionmanagement.sameprofiles': 'Отправитель такой же, как и получатель',
  'commissionmanagement.deleteconfirm':
    'Вы действительно хотите удалить запрос на снятие баллов?',
  'commissionmanagement.deletesucess':
    'Запрос на снятие средств успешно удален',
  'commissionmanagement.customer': 'клиент',
  'commissionmanagement.employee': 'Сотрудники',
  'commissionmanagement.request': 'Запросы',
  'commissionmanagement.income': 'Ваш доход',
  'commissionmanagement.wallet': 'Обновите свой кошелек',
  'commissionmanagement.customerregion': 'Регион на основе клиента',
  'commissionmanagement.totalpoint': 'Общее количество очков',
  'commissionmanagement.requestprice': 'Запрошенная сумма',
  'commissionmanagement.sendsms': 'Отправить смс',
  'commissionmanagement.requestpoint': 'Запрошенная точка',
  'commissionmanagement.wallettransaction': 'Последние транзакции кошелька',
  'commissionmanagement.recenttransactions': 'Недавние транзакции',
  'commissionmanagement.pointtransactions': 'Балльные транзакции',
  'commissionmanagement.transitional': 'Переходный',
  'commissionmanagement.exitfeepayment': 'Комиссия за выход из платежа',
  'commissionmanagement.moneydescription':
    'Вы можете конвертировать свои баллы в деньги и положить их на свой банковский счет.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'Таким образом, вы можете передавать свои баллы пользователям Tripsi.',
  'commissionmanagement.transferpointdescriptionTripord':
    'Таким образом, вы можете передавать свои баллы пользователям Tripord.',
  'commissionmanagement.getpointdescription':
    'Есть несколько способов увеличить свои баллы и получить бесплатные поездки .',
  'commissionmanagement.spendpointdescription':
    'Вы можете использовать свои баллы в разных разделах и пользоваться бесплатными услугами.',
  'commissionmanagement.buycarddescription':
    'Через баллы можно бесплатно получить карту Хамра Аваля, Иранселла и Талии.',
  'commissionmanagement.exitfeedescription':
    'С вашими баллами вы можете платить налоги на выезд.',
  'commissionmanagement.transfermoney': 'Перевести деньги',
  'commissionmanagement.buypoint': 'Купить балл',
  'commissionmanagement.safeway': 'Самый безопасный способ',
  'commissionmanagement.spendanywhere': 'Тратьте где угодно',
  'commissionmanagement.deposit': 'Депозит на счет',
  'commissionmanagement.easyway': 'Самый простой способ',
  'commissionmanagement.fastway': 'Самый быстрый способ',
  'commissionmanagement.entersecondpassword': 'Введите второй пароль',
  'commissionmanagement.usepoint': 'Мой дорогой друг, хорошо используй очки',
  'commissionmanagement.buyCard': 'Купить карту',
  'commissionmanagement.textRequest':
    'Вы можете конвертировать свои баллы в деньги, заполнив форму ниже.',
  'commissionmanagement.textTransferpoints':
    'Вы можете перевести свои баллы на счет другого пользователя, заполнив форму ниже.',
  'commissionmanagement.InternalServer': 'Внутренняя ошибка сервера',
};
